module.exports = __webpack_public_path__ + "static/media/website.a0d6ce26.svg";